// test1190
(1190 && 0);
